import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

interface RuleProps {
    $isExpanded?: boolean;
}
export const RuleWrapper = styled.div`
    position: relative;
    width: 100%;
    padding: 30px 0;
    border-bottom: 1px solid #a6a8f520;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 20px 0;
    }
`;

export const RuleTitle = styled.div<RuleProps>`
    padding: 0 40px 0 18px;
    font-weight: 700;
    font-size: 24px;
    line-height: 105%;
    letter-spacing: -0.02em;
    color: #fff;
    transition: transform 400ms cubic-bezier(0.33, 1, 0.68, 1);
    cursor: pointer;

    ${({ $isExpanded }) =>
        $isExpanded &&
        css`
            transform: translateX(-18px);
        `};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 20px;
    }
`;

export const RuleContent = styled(motion.div)`
    line-height: 149%;
    letter-spacing: -0.02em;
    overflow: hidden;
`;

export const RuleRemove = styled.div<RuleProps>`
    position: absolute;
    top: 50%;
    right: 48px;
    transform: translateY(-50%);
    transition: transform 400ms cubic-bezier(0.33, 1, 0.68, 1);
    ${({ $isExpanded }) =>
        $isExpanded &&
        css`
            transform: translateY(-50%) translateX(18px);
        `}
`;
export const RuleToggle = styled.button<RuleProps>`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 18px;
    width: 16px;
    height: 16px;
    background-color: transparent;
    border: 0;
    outline: 0;
    cursor: pointer;

    transition: transform 400ms cubic-bezier(0.33, 1, 0.68, 1);
    ${({ $isExpanded }) =>
        $isExpanded &&
        css`
            transform: translateY(-50%) translateX(18px);
        `};

    &::before,
    &::after {
        content: '';
        position: absolute;
        top: 7px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #fff;
        transition: transform 400ms cubic-bezier(0.33, 1, 0.68, 1);
    }
    &::after {
        transform: rotate(-90deg);
        ${({ $isExpanded }) =>
            $isExpanded &&
            css`
                transform: rotate(0deg);
            `};
    }
`;
